<template>
  <el-row>
    this is alarm
  </el-row>
</template>

<script>
export default {}
</script>

<style></style>
